import React from 'react';
import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  message?: string;
  onRetry: () => void;
}

export const ErrorRetry: React.FC<Props> = ({ message, onRetry }) => {
  const { t } = useTranslation('customer');
  return (
    <div style={{ padding: '24px 16px' }}>
      <Alert
        type="error"
        message={message ?? t('ui.errorRetry.defaultMessage')}
        style={{ marginBottom: 12 }}
      />
      <Button onClick={onRetry} block>
        {t('ui.errorRetry.retryBtn')}
      </Button>
    </div>
  );
};
